import styles from './styles.module.scss';
const { spinner } = styles;

const Spinner = () => <div className={spinner}></div>;

export default Spinner;
